import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarSingleUserPickerRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_single_user_picker');
	},
};

export default JiraAiAgentAvatarSingleUserPickerRelayProvider;
